import styled from 'styled-components';
import PlacesAutocomplete from "react-google-autocomplete";


export const PlaceInput = styled(PlacesAutocomplete)`
    padding: 4px 11px ;
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,'Noto Sans',sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol','Noto Color Emoji'; 
`;
